import { createSelector } from "reselect"
import { find, last, first, chain } from "lodash"
import { computeData } from "modules/analyze-composite-forecast/selectors/data"
import { DATABASE_DATE_FORMAT } from "helpers/formatters/dates"

const getSelectedDate = (_, props) => props.selectedDate
const getAllCategoryItems = (_, props) => props.allCategoryItems
const getDailyForecastData = (_, props) => props.dailyForecastData

const getContributorData = createSelector(
  [getAllCategoryItems, getDailyForecastData],
  computeData,
)

const getLastContributor = createSelector(
  [getContributorData],
  last,
)

// This is jump straight to the contributors drilldown
export const getSelectedContributorCategory = createSelector(
  [getAllCategoryItems],
  first,
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getLastContributor],
  (data, date, items, lastContributor) => {
    let dayData = {}

    if (lastContributor) {
      if (date === lastContributor.date.format(DATABASE_DATE_FORMAT)) {
        dayData = lastContributor
      } else {
        const contributor = find(data, day => date === day.date.format(DATABASE_DATE_FORMAT))
        if (contributor) {
          dayData = contributor
        }
      }
    }

    return chain(items)
      .map(item => ({
        label: item.label,
        id: item.id,
        value: dayData[item.id],
        color: item.color,
        category: item.category,
        favorite: item.favorite,
        field: item.field,
      }))
      .filter(item => item.value || item.favorite)
      .value()
  },
)

export const getSelectedContributorValue = createSelector(
  [getDetails, getSelectedContributorCategory],
  (contributors, selected) => {
    if (!selected) {
      return 0
    }

    const item = find(contributors, d => d.id === selected.id)
    if (item) {
      return item.value
    }
    return 0
  },
)
